import { FeedbackVideo } from "./FeedbackVideo";

const PROCESS_VIDEOS = [
  { id: "01", name: "US facility", slug: "01-facility" },
  { id: "02", name: "Clinical dosing", slug: "02-clinical-dosing" },
  { id: "03", name: "Test blends", slug: "03-test-blend" },
  { id: "04", name: "Fill line", slug: "04-fill-line" },
];

export const FeedbackProcess = () => (
  <section className="border-b border-[color:var(--line)] bg-[#faf9f5]" data-testid="feedback-process-section">
    <div className="mx-auto max-w-site px-6 py-24 md:px-10 md:py-32">
      <div className="grid grid-cols-1 gap-8 md:grid-cols-12">
        <div className="md:col-span-4">
          <div className="sample-label-accent label !text-[10px]" data-testid="feedback-process-label">The process</div>
        </div>
        <div className="md:col-span-8">
          <h2 className="font-display text-4xl leading-[1.02] sm:text-5xl" data-testid="feedback-process-title">
            Blended in the US.<br /><span className="editorial font-normal">Tested by Eurofins.</span>
          </h2>
          <p className="mt-6 max-w-3xl text-[15px] leading-relaxed text-[color:var(--ink-2)]" data-testid="feedback-process-intro">
            We partnered with a world-class co-manufacturer—a GMP-certified, FDA-registered dietary supplement facility in the United States—and Eurofins, the global leader in dietary supplement testing, which checks every batch for heavy metals, toxins, purity and potency.
          </p>
        </div>
      </div>

      <div className="mt-14 grid grid-cols-2 gap-2 lg:grid-cols-4" data-testid="feedback-process-video-grid">
        {PROCESS_VIDEOS.map((item) => (
          <article key={item.id} className="relative aspect-[9/16] overflow-hidden bg-[#0f0f10]" data-testid={`feedback-process-video-card-${item.id}`}>
            <FeedbackVideo
              poster={`/assets/feedback/process-video/${item.slug}-poster.jpg`}
              className="absolute inset-0 h-full w-full object-cover"
              data-testid={`feedback-process-video-${item.id}`}
              aria-label={`Vitura process: ${item.name}`}
            >
              <source src={`/assets/feedback/process-video/${item.slug}.webm`} type="video/webm" />
              <source src={`/assets/feedback/process-video/${item.slug}.mp4`} type="video/mp4" />
            </FeedbackVideo>
            <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-black/80 to-transparent" />
            <div className="absolute inset-x-4 bottom-4 flex items-center justify-between text-white">
              <span className="sample-accent font-mono text-[9px]" data-testid={`feedback-process-video-number-${item.id}`}>{item.id}</span>
              <span className="label !text-[8px] !text-white/80">{item.name}</span>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);